import React, { useState, useEffect } from "react";
import "./login.scss";
import logo from "../../assets/LargeLogo.png";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

import {
  useMsal,
  useIsAuthenticated,
} from "@azure/msal-react";
import {
  InteractionStatus,
} from "@azure/msal-browser";
import { loginRequest } from "../../utils/authConfig";

const Login = (props) => {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts, inProgress } = useMsal();
  const navigate = useNavigate();
  const [loggedIn, setloggedIn] = useState(false);

  useEffect(() => {
    // Redirect to service request list when authenticated and MSAL is ready
    console.log("Auth check:", { isAuthenticated, accountsLength: accounts?.length, inProgress });
    if (isAuthenticated && accounts && accounts.length > 0 && inProgress === InteractionStatus.None) {
      console.log("User authenticated, redirecting to /serviceRequestList");
      navigate("/serviceRequestList");
    }
  }, [isAuthenticated, accounts, inProgress, navigate]);

  const userLogin = () => {
    setloggedIn(true);
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error("Login error:", e);
    });
  };

  // Show loading screen while MSAL initializes
  if (inProgress === InteractionStatus.Startup) {
    return (
      <div className="App">
        <div className="head">
          <img className="logo" src={logo} alt="logo" />
          <h1 className="title">GUARD</h1>
        </div>
        <div className="body">
          <div className="auth-text">Initializing...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <>
        <div className="head">
          <img className="logo" src={logo} alt="logo" />
          <h1 className="title">GUARD</h1>
        </div>
        <div className="body">
          {inProgress === InteractionStatus.Login ? (
            <div className="auth-text">Logging in...</div>
          ) : (
            <Button className="login-btn" onClick={userLogin}>
              Login
            </Button>
          )}
        </div>
      </>
    </div>
  );
};

export default Login;
